module.exports = __webpack_public_path__ + "img/award-a.e6c0176f.png";